// import React, { useState, useEffect } from "react";
// import {
//   Form,
//   Button,
//   Container,
//   Row,
//   Col,
//   OverlayTrigger,
//   Tooltip,
// } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import Select from "react-select";
// import callingleads from "../../assets/images/offer-gifts-format.csv";

// const API_URL = process.env.REACT_APP_API_URL;

// function AddOfferGifts() {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     project_id: [],
//     project_name: [],
//   });

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [projects, setProjects] = useState([]);
//   const [file, setFile] = useState(null);
//   const [selectedOptions, setSelectedOptions] = useState([]);

//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });

//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//     });
//   };

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   useEffect(() => {
//     const fetchProjectsList = async () => {
//       setLoading(true);
//       try {
//         const token = getAuthToken();
//         if (!token) {
//           showCustomMessageModal(
//             "Authentication Error",
//             "Authentication token not found. Please log in.",
//             "error",
//           );
//           return;
//         }

//         const response = await fetch(`${API_URL}/project-list-block`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!response.ok) {
//           const errorData = await response.json();
//           showCustomMessageModal(
//             "Error",
//             errorData.message || "Failed to fetch projects.",
//             "error",
//           );
//           return;
//         }

//         const data = await response.json();
//         setProjects(data.data || []);
//       } catch (err) {
//         console.error("Fetch projects error:", err);
//         showCustomMessageModal(
//           "Error",
//           err.message ||
//             "An unexpected error occurred while fetching projects.",
//           "error",
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjectsList();
//   }, []);

//   // Convert projects to react-select format
//   const projectOptions = projects.map((project) => ({
//     value: project.id,
//     label: project.name,
//   }));

//   const handleProjectChange = (selected) => {
//     setSelectedOptions(selected || []);

//     const projectIds = selected.map((option) => option.value);
//     const projectNames = selected.map((option) => option.label);

//     setFormData({
//       project_id: projectIds,
//       project_name: projectNames,
//     });

//     if (errors.project_id) {
//       setErrors((prevErrors) => ({
//         ...prevErrors,
//         project_id: null,
//       }));
//     }
//   };

//   const validateForm = () => {
//     let newErrors = {};
//     let isValid = true;

//     if (formData.project_id.length === 0) {
//       newErrors.project_id = "Please select at least one project.";
//       isValid = false;
//     }

//     setErrors(newErrors);
//     return isValid;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       Swal.fire({
//         icon: "error",
//         title: "Validation Error",
//         text: "Please correct the errors in the form.",
//       });
//       return;
//     }

//     if (!file) {
//       Swal.fire({
//         icon: "error",
//         title: "No CSV File",
//         text: "Please select a CSV file before submitting.",
//       });
//       return;
//     }

//     setLoading(true);

//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         return;
//       }

//       const uploadData = new FormData();
//       uploadData.append("giftCsv", file);
//       uploadData.append("project_id", JSON.stringify(formData.project_id));
//       uploadData.append("project_name", JSON.stringify(formData.project_name));

//       console.log("Project IDs Array:", formData.project_id);
//       console.log("Project Names Array:", formData.project_name);

//       const response = await fetch(`${API_URL}/gift-create-csv`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: uploadData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal(
//           "Error",
//           errorData.message || "Failed to create Offer.",
//           "error",
//         );
//         return;
//       }

//       const result = await response.json();
//       if (result.success === "1") {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: result.message,
//           confirmButtonText: "OK",
//         });

//         setFormData({
//           project_id: [],
//           project_name: [],
//         });
//         setSelectedOptions([]);
//         setErrors({});
//         setFile(null);

//         setTimeout(() => {
//           navigate("/all-offer-gifts");
//         }, 2000);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: result.message || "Something went wrong!",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (err) {
//       console.error("Error creating offer:", err);
//       showCustomMessageModal(
//         "Error",
//         err.message || "An unexpected error occurred.",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Custom styles for react-select (modern theme)
//   const customStyles = {
//     control: (base, state) => ({
//       ...base,
//       borderColor: errors.project_id
//         ? "#dc3545"
//         : state.isFocused
//         ? "#2b6cb0"
//         : "#e2e8f0",
//       borderWidth: "1.5px",
//       borderRadius: "10px",
//       minHeight: "42px",
//       boxShadow: state.isFocused
//         ? "0 0 0 3px rgba(43, 108, 176, 0.15)"
//         : "none",
//       "&:hover": {
//         borderColor: errors.project_id ? "#dc3545" : "#2b6cb0",
//       },
//     }),
//     multiValue: (base) => ({
//       ...base,
//       backgroundColor: "#1e5799",
//       borderRadius: "6px",
//     }),
//     multiValueLabel: (base) => ({
//       ...base,
//       color: "white",
//       fontWeight: "600",
//       fontSize: "13px",
//     }),
//     multiValueRemove: (base) => ({
//       ...base,
//       color: "white",
//       ":hover": {
//         backgroundColor: "#dc3545",
//         color: "white",
//       },
//     }),
//     placeholder: (base) => ({
//       ...base,
//       color: "#94a3b8",
//       fontSize: "14px",
//     }),
//   };

//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               🎁
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Create New Offer / Gifts
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Upload CSV and select projects to create offers / gifts
//               </p>
//             </div>

//             <OverlayTrigger
//               placement="top"
//               overlay={<Tooltip>Download Offer/Gifts Format</Tooltip>}
//             >
//               <a
//                 href={callingleads}
//                 download="Offer Gifts Creation Format.csv"
//                 style={{
//                   padding: "12px 20px",
//                   borderRadius: "12px",
//                   border: "none",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   fontWeight: "700",
//                   fontSize: "14px",
//                   textDecoration: "none",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
//                 }}
//               >
//                 📥 Download CSV
//               </a>
//             </OverlayTrigger>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "28px" }}>
//               <Form onSubmit={handleSubmit}>
//                 <Row className="g-4 align-items-end">
//                   {/* Select Projects */}
//                   <Col md={5}>
//                     <Form.Group controlId="formProjectId">
//                       <Form.Label
//                         style={{
//                           display: "block",
//                           fontSize: "12.5px",
//                           fontWeight: "700",
//                           color: "#1e3a5f",
//                           marginBottom: "6px",
//                         }}
//                       >
//                         Select Projects <span className="text-danger">*</span>
//                       </Form.Label>

//                       <Select
//                         isMulti
//                         options={projectOptions}
//                         value={selectedOptions}
//                         onChange={handleProjectChange}
//                         styles={customStyles}
//                         isDisabled={loading || projects.length === 0}
//                         placeholder="Select projects..."
//                         noOptionsMessage={() => "No projects available"}
//                         loadingMessage={() => "Loading projects..."}
//                         isSearchable={true}
//                         closeMenuOnSelect={false}
//                       />

//                       {errors.project_id && (
//                         <div className="text-danger small mt-1">
//                           {errors.project_id}
//                         </div>
//                       )}

//                       {loading && projects.length === 0 && (
//                         <small className="text-muted">
//                           Loading projects...
//                         </small>
//                       )}

//                       {!loading && projects.length === 0 && (
//                         <small className="text-danger">
//                           No projects available. Please create one first.
//                         </small>
//                       )}
//                     </Form.Group>
//                   </Col>

//                   {/* Upload CSV */}
//                   <Col md={5}>
//                     <Form.Group controlId="formFile">
//                       <Form.Label
//                         style={{
//                           display: "block",
//                           fontSize: "12.5px",
//                           fontWeight: "700",
//                           color: "#1e3a5f",
//                           marginBottom: "6px",
//                         }}
//                       >
//                         Upload CSV File <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="file"
//                         accept=".csv"
//                         onChange={(e) => {
//                           const selectedFile = e.target.files[0];
//                           if (!selectedFile) return;

//                           const fileExtension = selectedFile.name
//                             .split(".")
//                             .pop()
//                             .toLowerCase();
//                           if (fileExtension !== "csv") {
//                             Swal.fire({
//                               icon: "error",
//                               title: "Invalid File",
//                               text: "Only CSV files are allowed!",
//                             });
//                             e.target.value = null;
//                             setFile(null);
//                             return;
//                           }
//                           setFile(selectedFile);
//                         }}
//                         style={{
//                           padding: "10px 14px",
//                           borderRadius: "10px",
//                           border: "1.5px solid #e2e8f0",
//                           fontSize: "14px",
//                         }}
//                       />
//                       <Form.Text className="text-muted">
//                         Please upload a CSV file in the correct format.
//                       </Form.Text>
//                     </Form.Group>
//                   </Col>

//                   {/* Submit Button */}
//                   <Col md={2}>
//                     <Button
//                       type="submit"
//                       disabled={loading}
//                       style={{
//                         width: "100%",
//                         padding: "12px 16px",
//                         borderRadius: "12px",
//                         border: "none",
//                         background: loading
//                           ? "#94a3b8"
//                           : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                         color: "#ffffff",
//                         fontWeight: "700",
//                         fontSize: "14px",
//                         cursor: loading ? "not-allowed" : "pointer",
//                         boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
//                       }}
//                     >
//                       {loading ? "Creating..." : "Create Offer"}
//                     </Button>
//                   </Col>
//                 </Row>
//               </Form>
//             </div>
//           </div>

//           {/* Footer */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>
//     </>
//   );
// }

// export default AddOfferGifts;

import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import callingleads from "../../assets/images/offer-gifts-format.csv";

const API_URL = process.env.REACT_APP_API_URL;

function AddOfferGifts() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    project_id: [],
    project_name: [],
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [file, setFile] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });

  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  const getAuthToken = () => {
    return localStorage.getItem("token");
  };

  useEffect(() => {
    const fetchProjectsList = async () => {
      setLoading(true);
      try {
        const token = getAuthToken();
        if (!token) {
          showCustomMessageModal(
            "Authentication Error",
            "Authentication token not found. Please log in.",
            "error",
          );
          return;
        }

        const response = await fetch(`${API_URL}/project-list-block`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          showCustomMessageModal(
            "Error",
            errorData.message || "Failed to fetch projects.",
            "error",
          );
          return;
        }

        const data = await response.json();
        setProjects(data.data || []);
      } catch (err) {
        console.error("Fetch projects error:", err);
        showCustomMessageModal(
          "Error",
          err.message ||
            "An unexpected error occurred while fetching projects.",
          "error",
        );
      } finally {
        setLoading(false);
      }
    };

    fetchProjectsList();
  }, []);

  // Convert projects to react-select format
  const projectOptions = projects.map((project) => ({
    value: project.id,
    label: project.name,
  }));

  const handleProjectChange = (selected) => {
    setSelectedOptions(selected || []);

    const projectIds = selected.map((option) => option.value);
    const projectNames = selected.map((option) => option.label);

    setFormData({
      project_id: projectIds,
      project_name: projectNames,
    });

    if (errors.project_id) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        project_id: null,
      }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    let isValid = true;

    if (formData.project_id.length === 0) {
      newErrors.project_id = "Please select at least one project.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please correct the errors in the form.",
      });
      return;
    }

    if (!file) {
      Swal.fire({
        icon: "error",
        title: "No CSV File",
        text: "Please select a CSV file before submitting.",
      });
      return;
    }

    setLoading(true);

    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error",
        );
        return;
      }

      const uploadData = new FormData();
      uploadData.append("giftCsv", file);
      uploadData.append("project_id", JSON.stringify(formData.project_id));
      uploadData.append("project_name", JSON.stringify(formData.project_name));

      console.log("Project IDs Array:", formData.project_id);
      console.log("Project Names Array:", formData.project_name);

      const response = await fetch(`${API_URL}/gift-create-csv`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: uploadData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        showCustomMessageModal(
          "Error",
          errorData.message || "Failed to create Offer.",
          "error",
        );
        return;
      }

      const result = await response.json();
      if (result.success === "1") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: result.message,
          confirmButtonText: "OK",
        });

        setFormData({
          project_id: [],
          project_name: [],
        });
        setSelectedOptions([]);
        setErrors({});
        setFile(null);

        setTimeout(() => {
          navigate("/all-offer-gifts");
        }, 2000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.message || "Something went wrong!",
          confirmButtonText: "OK",
        });
      }
    } catch (err) {
      console.error("Error creating offer:", err);
      showCustomMessageModal(
        "Error",
        err.message || "An unexpected error occurred.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  // Custom styles for react-select (modern theme)
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.project_id
        ? "#dc3545"
        : state.isFocused
        ? "#2b6cb0"
        : "#e2e8f0",
      borderWidth: "1.5px",
      borderRadius: "10px",
      minHeight: "42px",
      boxShadow: state.isFocused
        ? "0 0 0 3px rgba(43, 108, 176, 0.15)"
        : "none",
      "&:hover": {
        borderColor: errors.project_id ? "#dc3545" : "#2b6cb0",
      },
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#1e5799",
      borderRadius: "6px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "white",
      fontWeight: "600",
      fontSize: "13px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "white",
      ":hover": {
        backgroundColor: "#dc3545",
        color: "white",
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: "#94a3b8",
      fontSize: "14px",
    }),

    // 🔥 NEW — Dropdown Menu Fix (portal se bahar render hoga)
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0 8px 24px rgba(30, 87, 153, 0.15)",
      border: "1.5px solid #e2e8f0",
      overflow: "hidden",
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: "220px",
      padding: "4px",
    }),
    option: (base, state) => ({
      ...base,
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: "500",
      backgroundColor: state.isSelected
        ? "#1e5799"
        : state.isFocused
        ? "#e6f0fa"
        : "white",
      color: state.isSelected ? "white" : "#1e3a5f",
      cursor: "pointer",
      padding: "10px 12px",
      ":active": {
        backgroundColor: "#2b6cb0",
      },
    }),
  };

  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              🎁
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Create New Offer / Gifts
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Upload CSV and select projects to create offers / gifts
              </p>
            </div>

            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Download Offer/Gifts Format</Tooltip>}
            >
              <a
                href={callingleads}
                download="Offer Gifts Creation Format.csv"
                style={{
                  padding: "12px 20px",
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontWeight: "700",
                  fontSize: "14px",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
                }}
              >
                📥 Download CSV
              </a>
            </OverlayTrigger>
          </div>

          {/* 🎯 MAIN CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              overflow: "visible",   // 🔥 FIX: hidden → visible
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
                borderTopLeftRadius: "16px",      // 🔥 FIX: top corners
                borderTopRightRadius: "16px",
              }}
            />

            <div style={{ padding: "28px" }}>
              <Form onSubmit={handleSubmit}>
                <Row className="g-4 align-items-end">
                  {/* Select Projects */}
                  <Col md={5}>
                    <Form.Group controlId="formProjectId">
                      <Form.Label
                        style={{
                          display: "block",
                          fontSize: "12.5px",
                          fontWeight: "700",
                          color: "#1e3a5f",
                          marginBottom: "6px",
                        }}
                      >
                        Select Projects <span className="text-danger">*</span>
                      </Form.Label>

                      <Select
                        isMulti
                        options={projectOptions}
                        value={selectedOptions}
                        onChange={handleProjectChange}
                        styles={customStyles}
                        isDisabled={loading || projects.length === 0}
                        placeholder="Select projects..."
                        noOptionsMessage={() => "No projects available"}
                        loadingMessage={() => "Loading projects..."}
                        isSearchable={true}
                        closeMenuOnSelect={false}
                        menuPortalTarget={document.body}    // 🔥 FIX
                        menuPosition="fixed"                 // 🔥 FIX
                        menuPlacement="auto"                 // 🔥 FIX
                      />

                      {errors.project_id && (
                        <div className="text-danger small mt-1">
                          {errors.project_id}
                        </div>
                      )}

                      {loading && projects.length === 0 && (
                        <small className="text-muted">
                          Loading projects...
                        </small>
                      )}

                      {!loading && projects.length === 0 && (
                        <small className="text-danger">
                          No projects available. Please create one first.
                        </small>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Upload CSV */}
                  <Col md={5}>
                    <Form.Group controlId="formFile">
                      <Form.Label
                        style={{
                          display: "block",
                          fontSize: "12.5px",
                          fontWeight: "700",
                          color: "#1e3a5f",
                          marginBottom: "6px",
                        }}
                      >
                        Upload CSV File <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".csv"
                        onChange={(e) => {
                          const selectedFile = e.target.files[0];
                          if (!selectedFile) return;

                          const fileExtension = selectedFile.name
                            .split(".")
                            .pop()
                            .toLowerCase();
                          if (fileExtension !== "csv") {
                            Swal.fire({
                              icon: "error",
                              title: "Invalid File",
                              text: "Only CSV files are allowed!",
                            });
                            e.target.value = null;
                            setFile(null);
                            return;
                          }
                          setFile(selectedFile);
                        }}
                        style={{
                          padding: "10px 14px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          fontSize: "14px",
                        }}
                      />
                      <Form.Text className="text-muted">
                        Please upload a CSV file in the correct format.
                      </Form.Text>
                    </Form.Group>
                  </Col>

                  {/* Submit Button */}
                  <Col md={2}>
                    <Button
                      type="submit"
                      disabled={loading}
                      style={{
                        width: "100%",
                        padding: "12px 16px",
                        borderRadius: "12px",
                        border: "none",
                        background: loading
                          ? "#94a3b8"
                          : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        color: "#ffffff",
                        fontWeight: "700",
                        fontSize: "14px",
                        cursor: loading ? "not-allowed" : "pointer",
                        boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
                      }}
                    >
                      {loading ? "Creating..." : "Create Offer"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>

          {/* Footer */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>
    </>
  );
}

export default AddOfferGifts;